import { getIconPathFromBadgeId } from '@/utils';
import { Image, ImageProps } from '@chakra-ui/react';

export const PlumeBadge = ({
  badgeId,
  earned = false,
  ...props
}: { badgeId: string; earned?: boolean } & ImageProps) => {
  return <Image src={getIconPathFromBadgeId(badgeId, earned)} boxSize={16} {...props} />;
};
